import React, { useState, useRef } from "react";
import { MdCancel } from "react-icons/md";
import Button from "../../../../components/Button/Button";
import TextInput from "../../../../components/Input/Input";
import { MdImage } from "react-icons/md";
import { storage } from "../../../../firebaseconfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Loader from "../../../../components/Loader/Loader";
import { CategoryService } from "../CategoryService";
import { toast } from "react-toastify";

const AddCategory: React.FC<any> = ({ onClose }) => {
  const [selectedImage, setSelectedImage] = useState<string | null>("");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [laoding, setLoading] = useState<boolean>(false);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("handleImageChange");
    const file = e.target.files?.[0];

    if (file) {
      const fileRef = ref(storage, `uploads/${file.name}`);
      setLoading(true);
      uploadBytes(fileRef, file)
        .then(async () => {
          console.log("Uploaded file successfully");
          const resURL = await getDownloadURL(fileRef);
          console.log("resURL", resURL);
          setSelectedImage(resURL);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    }
  };

  const onHandleSave = async () => {
    const dataBody = {
      title: name,
      description,
      image_url: selectedImage,
    };

    try {
      setLoading(true);
      const res: any = await CategoryService.createCategory(dataBody);
      setLoading(false);
      if (res.status === 201) {
        toast.success("Category created successfully!", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        onClose();
      } else {
      }
    } catch (e) {
      console.error("Error saving category:", e);
    }
  };

  return (
    <div className="w-full h-full bg-black bg-opacity-30 fixed z-10 top-0 right-0 flex items-center justify-center">
      <div className="w-[25rem] h-fit p-5 bg-white rounded-xl shadow-md">
        <div className="flex justify-between items-center">
          <h3 className="font-poppins font-medium text-md">Add Category</h3>
          <h3
            onClick={onClose}
            className="font-poppins font-medium text-md cursor-pointer"
          >
            <MdCancel />
          </h3>
        </div>

        <div>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: "none" }}
            ref={fileInputRef}
          />
          <div
            className={`w-full flex flex-col items-center justify-center h-[10rem] mt-3 rounded-xl cursor-pointer border-2 border-dashed border-gray-300 ${
              selectedImage ? "!border-0" : "border-2"
            }`}
            onClick={() => {
              console.log("Div clicked");
              fileInputRef.current?.click();
            }}
          >
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="Selected"
                className="h-full w-full object-cover rounded-xl"
              />
            ) : (
              <>
                <MdImage size={40} className="text-gray-300" />
                <h3 className="font-poppins font-medium text-md text-gray-800">
                  Add Image
                </h3>
              </>
            )}
          </div>
        </div>

        <TextInput
          placeholder="Category Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextInput
          placeholder="Category Description"
          onChange={(e) => setDescription(e.target.value)}
          value={description}
        />

        <Button
          onClick={onHandleSave}
          disabled={false}
          className="!bg-blue-500 text-white !w-full"
        >
          {laoding ? <Loader /> : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default AddCategory;
